import { Params } from '@angular/router';

import { Action } from '@ngrx/store';

import { SortInfo } from '@stylehaven/components';
import { PaginationPreferences } from '../../record/entities/pagination/pagination-preferences.entity';
import { RecordSearch } from '../../record/entities/record-search.entity';

export enum OverviewOptionsActionTypes {
    SetPagination = '[OverviewOptions] Set Pagination',
    SetSort = '[OverviewOptions] Set Sort',
    SetQueryParams = '[OverviewOptions] Set QueryParams',
    SetRecordSearch = '[OverviewOptions] Set RecordSearch',
    SetBackToSearchLabel = '[OverviewOptions] Set BackToSearchLabel',
    SetExpandedIds = '[OverviewOptions] Set ExpandedIds'
}

export class SetPaginationPreferences implements Action {
    type: OverviewOptionsActionTypes.SetPagination = OverviewOptionsActionTypes.SetPagination;
    constructor(
        public overview: string,
        public pagination: PaginationPreferences
    ) {}
}

export class SetSort implements Action {
    type: OverviewOptionsActionTypes.SetSort = OverviewOptionsActionTypes.SetSort;
    constructor(
        public overview: string,
        /** `undefined` is a clear, not a no-op: it drops the stored sort and hands the view back its default. */
        public sort: SortInfo | undefined
    ) {}
}

export class SetQueryParams implements Action {
    type: OverviewOptionsActionTypes.SetQueryParams = OverviewOptionsActionTypes.SetQueryParams;
    constructor(
        public overview: string,
        public queryParams?: Params
    ) {}
}

export class SetRecordSearch implements Action {
    type: OverviewOptionsActionTypes.SetRecordSearch = OverviewOptionsActionTypes.SetRecordSearch;
    constructor(
        public overview: string,
        public recordSearch: RecordSearch
    ) {}
}

export class SetBackToSearchLabel implements Action {
    type: OverviewOptionsActionTypes.SetBackToSearchLabel = OverviewOptionsActionTypes.SetBackToSearchLabel;
    constructor(
        public overview: string,
        public label: string
    ) {}
}

export class SetExpandedIds implements Action {
    type: OverviewOptionsActionTypes.SetExpandedIds = OverviewOptionsActionTypes.SetExpandedIds;
    constructor(
        public overview: string,
        public expandedIds: string[]
    ) {}
}

export type OverviewOptionsAction =
    | SetSort
    | SetPaginationPreferences
    | SetQueryParams
    | SetRecordSearch
    | SetBackToSearchLabel
    | SetExpandedIds;
